import { useEffect, useState } from "react";

const TARGET = new Date("2026-10-30T14:00:00+05:30").getTime();
const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ className = "" }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  const diff = TARGET - now;

  if (diff <= 0) {
    return (
      <div className={`text-center ${className}`} data-testid="conclave-countdown">
        <p className="text-xs uppercase tracking-[0.3em] text-gold">The Conclave Has Arrived</p>
        <p className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-ivory sm:text-5xl">
          Today · NDMC Convention Centre, New Delhi
        </p>
      </div>
    );
  }

  const units = [
    ["Days", Math.floor(diff / 86400000)],
    ["Hours", Math.floor((diff % 86400000) / 3600000)],
    ["Minutes", Math.floor((diff % 3600000) / 60000)],
    ["Seconds", Math.floor((diff % 60000) / 1000)],
  ];

  return (
    <div className={`text-center ${className}`} data-testid="conclave-countdown">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Countdown to the Conclave</p>
      <div className="mt-6 flex items-start justify-center gap-3 sm:gap-6">
        {units.map(([label, value]) => (
          <div
            key={label}
            className="min-w-[68px] border border-gold/25 bg-black/40 px-3 py-4 backdrop-blur-sm sm:min-w-[110px] sm:px-6 sm:py-6"
          >
            <p
              className="font-display text-3xl font-extrabold tracking-tight text-gold sm:text-5xl lg:text-6xl"
              data-testid={`countdown-${label.toLowerCase()}`}
            >
              {pad(value)}
            </p>
            <p className="mt-2 text-[10px] uppercase tracking-[0.25em] text-white/50 sm:text-xs">{label}</p>
          </div>
        ))}
      </div>
      <p className="mt-6 text-xs uppercase tracking-[0.2em] text-white/60 sm:text-sm">
        30 October 2026 · 2 PM IST · NDMC Convention Centre, New Delhi
      </p>
    </div>
  );
};

export default Countdown;
